/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PrintIcon from "@material-ui/icons/Print";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import "moment/locale/th";
import axios from "axios";
import { authHeader } from "_helpers";

moment.locale("th");

const useStyles = makeStyles(theme => ({
  paper: {
    padding: "36px 48px",
    fontFamily: '"Sarabun", "TH Sarabun New", "Tahoma", sans-serif',
    color: "#000",
    backgroundColor: "#fff"
  },
  voucherContainer: {
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
    fontFamily: '"TH Sarabun New", "Sarabun", "Tahoma", sans-serif',
    fontSize: "14pt",
    lineHeight: 1.65,
    color: "#000"
  },
  headerTitle: {
    fontSize: "16pt",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "4px"
  },
  headerSub: {
    fontSize: "16pt",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "20px"
  },
  salutation: {
    fontSize: "14pt",
    fontWeight: "bold",
    marginBottom: "12px"
  },
  narrativePara: {
    fontSize: "14pt",
    lineHeight: "1.7",
    marginBottom: "4px",
    textAlign: "justify"
  },
  boxedTable: {
    width: "90%",
    border: "1px solid #000 !important",
    borderCollapse: "collapse",
    margin: "16px 0 16px 48px",
    fontSize: "14pt",
    "& td": {
      border: "none !important",
      fontSize: "14pt"
    }
  },
  boxedCellLabel: {
    padding: "6px 16px",
    width: "150px",
    fontWeight: "normal",
    verticalAlign: "middle",
    border: "none !important",
    fontSize: "14pt"
  },
  boxedCellValue: {
    padding: "6px 16px",
    fontWeight: "normal",
    verticalAlign: "middle",
    border: "none !important",
    fontSize: "14pt"
  },
  boxedCellCode: {
    padding: "6px 16px",
    fontWeight: "normal",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    border: "none !important",
    fontSize: "14pt"
  },
  totalsTable: {
    margin: "10px 0 14px 40px",
    borderCollapse: "collapse",
    border: "none !important",
    width: "90%",
    fontSize: "14pt",
    "& td": {
      padding: "3px 12px",
      border: "none !important",
      fontSize: "14pt"
    },
    "& tr": {
      border: "none !important"
    }
  },
  signSection: {
    marginTop: "60px",
    display: "flex",
    justifyContent: "flex-end"
  },
  signBox: {
    width: "320px",
    textAlign: "center",
    fontSize: "14pt"
  },
  signLine: {
    borderBottom: "1px solid #000",
    width: "220px",
    margin: "0 auto 50px auto"
  },
  approvedText: {
    marginTop: "24px",
    paddingLeft: "100px",
    fontSize: "14pt",
    fontWeight: "bold"
  },
  "@media print": {
    dialogPaper: {
      boxShadow: "none !important",
      margin: "0 !important",
      maxWidth: "100% !important",
      width: "100% !important",
      padding: "0 !important",
      border: "none !important"
    },
    noPrint: {
      display: "none !important"
    },
    voucherContainer: {
      width: "100% !important",
      maxWidth: "100% !important",
      padding: "0 !important",
      margin: "0 auto !important",
      fontFamily: '"TH Sarabun New", "Sarabun", "Tahoma", sans-serif !important',
      fontSize: "18pt !important",
      lineHeight: "1.6 !important",
      color: "#000 !important",
      pageBreakInside: "avoid !important",
      breakInside: "avoid !important",
      pageBreakAfter: "avoid !important",
      breakAfter: "avoid !important"
    },
    headerTitle: {
      fontSize: "20pt !important",
      fontWeight: "bold !important",
      textAlign: "center !important",
      marginBottom: "6px !important",
      lineHeight: "1.4 !important"
    },
    headerSub: {
      fontSize: "20pt !important",
      fontWeight: "bold !important",
      textAlign: "center !important",
      marginBottom: "16px !important",
      lineHeight: "1.4 !important"
    },
    salutation: {
      fontSize: "18pt !important",
      fontWeight: "bold !important",
      marginBottom: "8px !important"
    },
    narrativePara: {
      fontSize: "18pt !important",
      lineHeight: "1.65 !important",
      marginBottom: "3px !important"
    },
    boxedTable: {
      width: "92% !important",
      border: "1px solid #000 !important",
      borderCollapse: "collapse !important",
      margin: "10px 0 10px 36px !important",
      fontSize: "18pt !important",
      "& td": {
        border: "none !important",
        padding: "3px 10px !important",
        fontSize: "18pt !important"
      }
    },
    totalsTable: {
      border: "none !important",
      margin: "6px 0 8px 30px !important",
      fontSize: "18pt !important",
      "& td": {
        border: "none !important",
        padding: "2px 8px !important",
        fontSize: "18pt !important"
      },
      "& tr": {
        border: "none !important"
      }
    },
    signSection: {
      marginTop: "20px !important",
      display: "flex !important",
      justifyContent: "flex-end !important"
    },
    signBox: {
      width: "320px !important",
      textAlign: "center !important",
      fontSize: "18pt !important"
    },
    signLine: {
      borderBottom: "1px solid #000 !important",
      width: "220px !important",
      margin: "0 auto 28px auto !important"
    },
    approvedText: {
      marginTop: "12px !important",
      fontSize: "18pt !important",
      fontWeight: "bold !important"
    }
  }
}));

export default function PrintProtectDialog({ open, onClose, data }) {
  const classes = useStyles();

  const [checkerPosition, setCheckerPosition] = useState("");

  useEffect(() => {
    if (!data) {
      setCheckerPosition("");
      return;
    }

    if (data.lastCheckerPosition || data.checkerPosition) {
      setCheckerPosition(data.lastCheckerPosition || data.checkerPosition);
      return;
    }

    const code = data.lastCheckerCode || data.checkerCode;
    if (code) {
      axios
        .get(`/api/v1/userview?FirstName=${encodeURIComponent(code)}`, {
          headers: authHeader()
        })
        .then(res => {
          const list = res.data?.data || [];
          const found = list.find(
            u => (u.userName || "").toLowerCase() === code.toLowerCase()
          );
          if (found && found.positionName) {
            setCheckerPosition(found.positionName);
          } else if (found?.userDepartment && found.userDepartment.length > 0) {
            const pos = found.userDepartment.find(d => d.positionName)?.positionName;
            if (pos) setCheckerPosition(pos);
          }
        })
        .catch(err => {
          console.error("Error fetching checker position:", err);
        });
    } else {
      setCheckerPosition("");
    }
  }, [data]);

  if (!data) return null;

  const handlePrint = () => {
    window.print();
  };

  const thaiDate = data.kDate
    ? moment(data.kDate)
        .add(543, "years")
        .format("D MMMM YYYY")
    : "-";

  const thaiSignDate = data.pDate
    ? moment(data.pDate)
        .add(543, "years")
        .format("D MMMM YYYY")
    : moment()
        .add(543, "years")
        .format("D MMMM YYYY");

  const depName = data.protectDepName || data.noteName || "ฝ่ายการเงินและบัญชี";

  // Checker verification info
  const isChecked = Boolean(
    data.checkerDT ||
    data.checkerCode ||
    data.lastCheckerDT ||
    data.lastCheckerCode
  );

  const activeCheckerCode = data.lastCheckerCode || data.checkerCode || "";
  const activeCheckerName = data.lastCheckerName || data.checkerName || activeCheckerCode;

  const checkerDate =
    data.lastCheckerDT || data.checkerDT
      ? moment(data.lastCheckerDT || data.checkerDT)
          .add(543, "years")
          .format("D MMMM YYYY")
      : thaiSignDate;

  const formatMoney = num =>
    (num != null ? Number(num) : 0).toLocaleString("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

  // Helper to cleanly separate Name and Code
  const parseNameAndCode = (rawName, fullName, explicitCode) => {
    let raw = (rawName || fullName || "").trim();
    let code = (explicitCode || "").trim();

    // If explicitCode was swapped with rawName in DB (e.g. code is text, name is digits)
    if (code && /^[^\d]+$/.test(code) && /^\d+$/.test(raw)) {
      const tmp = code;
      code = raw;
      raw = tmp;
    }

    // Check if "รหัส ..." is embedded in raw
    const matchRahas = raw.match(/รหัส\s*([0-9A-Za-z_-]+)/);
    if (matchRahas) {
      if (!code) code = matchRahas[1];
      raw = raw.replace(matchRahas[0], "").replace(/^[-\s/()]+|[-\s/()]+$/g, "").trim();
    }

    // If code is empty or missing, see if raw starts or ends with numeric/alnum code
    if (!code && raw) {
      const matchPrefix = raw.match(/^([0-9A-Za-z_-]{4,})\s+(.*)$/);
      if (matchPrefix) {
        code = matchPrefix[1];
        raw = matchPrefix[2];
      } else {
        const matchSuffix = raw.match(/^(.*?)\s+([0-9A-Za-z_-]{4,})$/);
        if (matchSuffix) {
          raw = matchSuffix[1];
          code = matchSuffix[2];
        }
      }
    }

    // If code is present, strip it from raw if it's still in raw
    if (code && raw) {
      raw = raw.replace(code, "").replace(/^[-\s/()]+|[-\s/()]+$/g, "").trim();
    }

    // Also strip any leading "รหัส" from code if present to avoid duplicate "รหัส"
    if (code.startsWith("รหัส")) {
      code = code.substring(4).trim();
    }

    return {
      name: raw || "-",
      code: code ? `รหัส ${code}` : ""
    };
  };

  const sourceInfo = parseNameAndCode(data.rawSourceName, data.sourceMoneyName, data.sourceId);
  const budgetInfo = parseNameAndCode(data.rawBudgetName, data.budgetName, data.bid2);
  const activityInfo = parseNameAndCode(data.rawActivityName, data.activityName, data.aid2);

  const displaySourceName = sourceInfo.name;
  const displayBudgetName = budgetInfo.name;
  const displayActivityName = activityInfo.name;

  const allMoney = data.allMoney || data.money || 0;
  const allReadyMoney = data.allReadyMoney || data.allMoney || data.money || 0;
  const remainMoney = data.remainMoney || 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ className: classes.dialogPaper }}
    >
      <style>{`
        @media print {
          @page {
            size: A4 portrait;
            margin: 0;
          }
          /* Hide background web app */
          #root,
          .sidebar,
          .navbar,
          .main-panel > .navbar,
          footer,
          .footer {
            display: none !important;
          }
          /* Reset Dialog positioning so it renders naturally in print */
          .MuiDialog-root {
            position: static !important;
            z-index: auto !important;
          }
          .MuiDialog-container {
            position: static !important;
            display: block !important;
            height: auto !important;
            padding: 0 !important;
          }
          .MuiDialog-paper {
            box-shadow: none !important;
            border: none !important;
            margin: 0 !important;
            padding: 0 !important;
            max-width: 100% !important;
            width: 100% !important;
            overflow: visible !important;
            background: #ffffff !important;
          }
          .MuiDialogTitle-root,
          .MuiDialogActions-root,
          .MuiBackdrop-root {
            display: none !important;
          }
          .MuiDialogContent-root,
          .MuiDialogContent-dividers {
            border: none !important;
            border-top: none !important;
            border-bottom: none !important;
            padding: 0 !important;
            margin: 0 !important;
            overflow: visible !important;
          }
          #printable-protect-voucher {
            display: block !important;
            box-sizing: border-box !important;
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 auto !important;
            padding: 30mm 15mm 15mm 15mm !important;
            page-break-inside: avoid !important;
            break-inside: avoid !important;
            page-break-after: avoid !important;
            break-after: avoid !important;
          }
        }
      `}</style>
      <DialogTitle
        disableTypography
        className={classes.noPrint}
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography variant="h6" style={{ fontWeight: "bold", color: "#1e3a8a" }}>
          พิมพ์ใบขออนุมัติกันเงินงบประมาณ
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.paper}>
        <div id="printable-protect-voucher" className={classes.voucherContainer}>
          {/* Header */}
          <div className={classes.headerTitle}>
            ใบกันเงินงบประมาณและเงินนอกงบประมาณ(เงินบำรุง)
          </div>
          <div className={classes.headerSub}>
            โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้จังหวัดตรัง
          </div>

          {/* Salutation */}
          <div className={classes.salutation}>เรียนผู้อำนวยการ</div>

          {/* Narrative Content */}
          <div className={classes.narrativePara} style={{ textIndent: "48px" }}>
            ตามบันทึกของ{depName}ที่ &nbsp;&nbsp;
            <b>{data.number}</b> &nbsp;&nbsp;&nbsp; ลงวันที่ &nbsp;&nbsp;
            {thaiDate}
          </div>
          <div className={classes.narrativePara} style={{ textIndent: "24px" }}>
            ขอจัดซื้อจัดจ้าง โดยใช้วิธี {data.method || "เฉพาะเจาะจง"} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ในวงเงิน <b>{formatMoney(data.money)}</b> บาท จาก {data.companyName || "-"}
          </div>
          <div className={classes.narrativePara} style={{ textIndent: "48px" }}>
            {depName} ขอจัดสรรโดยใช้เงิน
          </div>
          <div className={classes.narrativePara} style={{ textIndent: "48px", fontWeight: "bold" }}>
            {data.btypeName || "-"}
          </div>

          {/* Boxed Table */}
          <table className={classes.boxedTable} style={{ paddingLeft: "48px" }}>
            <tbody>
              <tr>
                <td className={classes.boxedCellLabel}>แหล่งของเงิน</td>
                <td className={classes.boxedCellValue}>{sourceInfo.name}</td>
                <td className={classes.boxedCellCode}>{sourceInfo.code}</td>
              </tr>
              <tr>
                <td className={classes.boxedCellLabel}>รหัสงบประมาณ</td>
                <td className={classes.boxedCellValue}>{budgetInfo.name}</td>
                <td className={classes.boxedCellCode}>{budgetInfo.code}</td>
              </tr>
              <tr>
                <td className={classes.boxedCellLabel}>กิจกรรมหลัก</td>
                <td className={classes.boxedCellValue}>{activityInfo.name}</td>
                <td className={classes.boxedCellCode}>{activityInfo.code}</td>
              </tr>
            </tbody>
          </table>

          {/* Financial Totals */}
          <table className={classes.totalsTable} border="0" style={{ border: "none" }}>
            <tbody>
              <tr>
                <td style={{ width: "220px" }}>ยอดเงินที่รับการจัดสรร</td>
                <td style={{ width: "60px" }}>จำนวน</td>
                <td style={{ width: "130px", textAlign: "right" }}>
                  {formatMoney(allMoney) } บาท
                </td>
                <td style={{ width: "50px" }}></td>
              </tr>
              <tr>
                <td>ยอดเงินที่ได้รับการจัดซื้อ/จ้างแล้ว</td>
                <td>จำนวน</td>
                <td style={{ textAlign: "right" }}>
                  {formatMoney(allReadyMoney)} บาท
                </td>
                <td></td>
              </tr>
              <tr>
                <td>ยอดเงินคงเหลือ</td>
                <td>จำนวน</td>
                <td style={{ textAlign: "right" }}>
                  {formatMoney(remainMoney)} บาท
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>

          {/* Concluding Paragraph */}
          <div className={classes.narrativePara} style={{ textIndent: "48px" }}>
            จึงเรียนมาเพื่อโปรดพิจารณาและอนุมัติให้{depName}ดำเนินการตามระเบียบต่อไป
          </div>

          {/* Signatures & Date */}
          <div className={classes.signSection}>
            <div className={classes.signBox}>
              {isChecked ? (
                <>
                  <div style={{ height: "45px" }} />
                  <div
                    className={classes.signLine}
                    style={{ margin: "0 auto 8px auto", width: "220px" }}
                  />
                  <div style={{ marginBottom: "4px" }}>
                    ( {activeCheckerName || "...................................................."} )
                  </div>
                  <div style={{ marginBottom: "6px" }}>
                    {checkerPosition || "...................................................."}
                  </div>
                  <div>{checkerDate}</div>
                </>
              ) : (
                <>
                  <div className={classes.signLine} />
                  <div
                    className={classes.signLine}
                    style={{ marginBottom: "16px" }}
                  />
                  <div>{thaiSignDate}</div>
                </>
              )}
            </div>
          </div>

          {/* Approval Word */}
          <div className={classes.approvedText} style={{ textIndent: "60px" }}>
            อนุมัติ
          </div>
        </div>
      </DialogContent>

      <DialogActions className={classes.noPrint} style={{ padding: "16px 24px" }}>
        <Button
          onClick={handlePrint}
          color="primary"
          variant="contained"
          startIcon={<PrintIcon />}
        >
          พิมพ์เอกสาร
        </Button>
        <Button onClick={onClose} color="default">
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
